var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKpassColoredSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 38,
    viewBox: "0 0 114 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "K-PASS Logo Secondary(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "K-PASS Logo Secondary(2)-\xEC\x97\xAC\xEB\xB0\xB1\xEC\x97\x86\xEC\x9D\x8C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.5891 17.9673H29.9335C29.0242 17.9673 28.2871 18.6942 28.2871 19.591C28.2871 20.4877 29.0242 21.2146 29.9335 21.2146H39.5891C40.4983 21.2146 41.2354 20.4877 41.2354 19.591C41.2354 18.6942 40.4983 17.9673 39.5891 17.9673Z",
    fill: "#583BE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7031 20.796L14.5981 23.191V26.6156H11.1445V11.3662H14.5981V18.5512L20.7813 11.3662H25.0119L18.9416 18.271L25.3353 26.6156H21.0295L16.7031 20.796Z",
    fill: "#583BE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.0254 11.3662H53.9639C57.9856 11.3662 60.3388 13.5739 60.3388 16.9427C60.3388 20.3116 57.9856 22.5564 53.9639 22.5564H51.479V26.6156H48.0254V11.3662ZM53.8116 19.542C55.7283 19.542 56.8852 18.644 56.8852 16.941C56.8852 15.238 55.7283 14.3773 53.8116 14.3773H51.479V19.542H53.8116Z",
    fill: "#383649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M70.0689 23.6585H64.0739L62.9923 26.6139H59.4258L65.4207 11.3662H69.0061L75.0011 26.6156H71.1505L70.0689 23.6602V23.6585ZM69.0061 20.7015L67.0705 15.3883L65.135 20.7015H69.0061Z",
    fill: "#383649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M88.491 15.969H84.9245C84.7157 14.6407 83.7111 13.8357 82.0596 13.8357C80.4082 13.8357 79.5559 14.472 79.5559 15.3884C79.5559 16.5294 80.7504 16.9227 83.7676 17.5404C87.3341 18.2695 88.5492 20.0097 88.5492 22.2933C88.5492 25.2115 85.7597 26.9904 82.3078 26.9904C78.4948 26.9904 75.7053 24.9516 75.5547 21.6958H79.1024C79.2923 23.1557 80.5827 24.1279 82.5559 24.1279C83.9593 24.1279 85.0032 23.4359 85.0032 22.4435C85.0032 21.2266 83.9593 20.7405 81.2091 20.2358C77.8514 19.6181 76.0305 18.2527 76.0305 15.3901C76.0305 12.5276 78.7978 10.9917 82.2873 10.9917C85.7768 10.9917 88.3199 13.0677 88.491 15.969Z",
    fill: "#383649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M102.796 15.969H99.2292C99.0204 14.6407 98.0158 13.8357 96.3643 13.8357C94.7128 13.8357 93.8606 14.472 93.8606 15.3884C93.8606 16.5294 95.0551 16.9227 98.0723 17.5404C101.639 18.2695 102.854 20.0097 102.854 22.2933C102.854 25.2115 100.064 26.9904 96.6125 26.9904C92.7995 26.9904 90.01 24.9516 89.8594 21.6958H93.4071C93.597 23.1557 94.8874 24.1279 96.8606 24.1279C98.264 24.1279 99.3079 23.4359 99.3079 22.4435C99.3079 21.2266 98.264 20.7405 95.5138 20.2358C92.156 19.6181 90.3351 18.2527 90.3351 15.3901C90.3351 12.5276 93.1007 10.9917 96.5919 10.9917C100.083 10.9917 102.625 13.0677 102.796 15.969Z",
    fill: "#383649"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpassColoredSecondary);
export default __webpack_public_path__ + "static/media/kpass_colored_secondary.2ae8478d813c64833cc27d7dbebb23fa.svg";
export { ForwardRef as ReactComponent };